import { memo, useMemo } from 'react'
import { useIntl } from 'react-intl'
import NavBarButton from '../NavBarButton/NavBarButton'
import config from 'constants/config'
import productLabels from 'i18n/productLabels'
import LineSuitcaseIcon from 'LuxKit/Icons/line/LineSuitcaseIcon'

interface Props {
  className?: string
}

function NavBarMyEscapesButton(props: Props) {
  const intl = useIntl()
  const buttonText = useMemo(() => {
    const purchaseSynonym = config.brandConfig.purchaseSynonym
    if (purchaseSynonym === 'booking') {
      return intl.formatMessage({
        id: 'uN-vVoJGfR6Xi1K4E_q6',
        defaultMessage: 'My Bookings',
        description: 'My escapes button text in navigation bar when purchaseSynonym is booking',
      })
    }
    if (purchaseSynonym === 'escape') {
      return intl.formatMessage(productLabels.myEscapes)
    }
    return intl.formatMessage({
      id: '-QOPCZu2uRwE-x1yuuqc',
      defaultMessage: 'My Purchases',
      description: 'My escapes button text in navigation bar when purchaseSynonym is purchase',
    })
  }, [intl])

  return <NavBarButton
    className={props.className}
    icon={<LineSuitcaseIcon />}
    to="/account/my-escapes"
  >
    {buttonText}
  </NavBarButton>
}

export default memo(NavBarMyEscapesButton)
